<div>
	<form [formGroup]="aiRuleForm">
		<div>
			<div class="form-group">
				<ds-input [label]="'ai_rules.name' | translate" formControlName="name"></ds-input>
				<ds-input-chip
					[label]="'ai_rules.prefix_list' | translate"
					formControlName="prefixList"
					[placeholder]="'ai_rules.separate' | translate"
				></ds-input-chip>

				<ds-select-dropdown-preset [options]="clientProductListTypes" formControlName="clientProductListType">
					<ds-select
						[label]="'ai_rules.client_product_list_type' | translate"
						[labelAsterisk]="true"
						slot="trigger"
					></ds-select>
				</ds-select-dropdown-preset>

				@if (config.eapiEnable) {
					<ds-multi-select-dropdown-preset
						[options]="clientProductsIds()"
						formControlName="productList"
						[search]="true"
						[displayOptionWith]="displayProduct.bind(this)"
						[virtualScroll]="true"
						[selectAllBtn]="true"
						[style]="'width: 100%'"
					>
						<ds-multi-select
							[maxRows]="3"
							[label]="'ai_rules.client_product' | translate"
							[labelAsterisk]="true"
							slot="trigger"
							[displayValueWith]="displayProduct.bind(this)"
						></ds-multi-select>
					</ds-multi-select-dropdown-preset>
				} @else {
					<ds-input [label]="'ai_rules.client_product' | translate" formControlName="productList"></ds-input>
				}

				<app-choice-form-array [sources]="sources()" formControlName="choiceList"></app-choice-form-array>
			</div>

			<div class="footer">
				<button
					dsButton
					class="w-35"
					[mode]="'main'"
					[view]="'normal'"
					(click)="save()"
					size="S"
					[disabled]="aiRuleForm.invalid || !aiRuleForm.dirty"
				>
					{{ (aiRuleForm.controls.id.value ? 'actions.save' : 'actions.create') | translate }}
				</button>

				<button dsButton class="w-35" [mode]="'main'" [view]="'normal'" type="button" (click)="close()" size="S">
					{{ 'actions.cancel' | translate }}
				</button>
			</div>
		</div>
	</form>
</div>
